// Utilities for version-control node menu item enablement and data serialization.

/**
 * Checks if a node is the synthetic uncheckpointed creation node.
 * Such nodes cannot be restored, hard-reset, branched, or compared.
 */
export function isCreationNode(node) {
  if (!node) return false
  // Uncheckpointed flag is set by the server; also check for all-zero UUID
  if (node.uncheckpointed === true) return true
  if (node.id && /^0{8}-0{4}-0{4}-0{4}-0{12}$/.test(node.id)) return true
  return false
}

/**
 * Serializes a checkpoint node to JSON for the Copy Data menu item.
 * Format: { id, label, branch, author, date }
 */
export function serializeNodeData(node, branchNameById) {
  return {
    id: node.id,
    label: node.label || '',
    branch: branchNameById?.get(node.branch_id) || '',
    author: node.created_by || 'unknown',
    date: node.created_at || '',
  }
}
